module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Regular.2ae16087.ttf";